import React from "react";
import './material.css';
import Navbar from "./Navbar";
import SideNav from './SideNav';


const Materials = () => {
    return (
        <>
            <Navbar/>
            <SideNav/>
        </>
    );
}
export default Materials;